'use client'

import { useEffect } from 'react'

export enum MobileBackButtonType {
    RESTAURANT_DETAIL = 'restaurant-detail-back-button',
}

// Initialize the mobile back button from a specific page (the page that the user should be taken back to when the back button is clicked)
// Reason: Using router.back() could potentially take the user back to a different website (like google) if the user came directly to the page
// To prevent this, we use sessionStorage to store a flag that tells the back button to use router.back() instead of the href
export const useMobileBackButtonInit = (type: MobileBackButtonType) => {
    useEffect(() => {
        if (typeof window === 'undefined') return

        window.sessionStorage.setItem(type, 'true')
    }, [type])
}
